import styled from 'styled-components'

export const Section = styled.section`
  background-color: #f5f7ff;
  padding: 14rem 0 10rem;

  @media (max-width: 999px) {
    padding-top: 10rem;
  }
`

export const Header = styled.div`
  margin-bottom: 12rem;

  @media (max-width: 1279px) {
    margin-bottom: 10rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 8rem;
  }
`
